import {
  AccountTypeForVersionManagement,
  AccountTypeForVersionManagementValues,
} from "types/orgTypes";

export function withDemoAndDistributorTypes<T extends string>(
  baseTypes: readonly T[],
  isAdmin: boolean,
): (T | AccountTypeForVersionManagement)[] {
  const extraTypes = isAdmin
    ? AccountTypeForVersionManagementValues
    : AccountTypeForVersionManagementValues.filter((type) => type !== "distributor");
  return [...baseTypes, ...extraTypes];
}
